import { Col } from 'antd';
import { useAppSelector, useQuery } from 'modules/hooks/appHooks';
import { LoginSelectors } from 'modules/landingPage/components/login/redux';
import { Button, ButtonType, Flex, BodyText, HeadlineTitle } from 'modules/ui';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { PasswordResetForm } from '../profilePage/components/passwordResetForm';
import {
  ThirdWidthRow,
  StyledBackButtonRow,
  StyledDescriptionRow,
} from './styled';

interface PasswordResetPageProps {}

export const PasswordResetPage: React.FC<PasswordResetPageProps> = () => {
  const { t } = useTranslation();
  const query = useQuery();
  const user = useAppSelector(LoginSelectors.selectUser);

  const forceReset = query.get('forceReset') === 'true';
  const name = useMemo(
    () => (user ? `${user.firstName} ${user.lastName}` : query.get('name')),
    [query, user],
  );
  const email = useMemo(
    () => (user ? user.email : query.get('email')),
    [user, query],
  );

  return (
    <Flex width="100%">
      <StyledBackButtonRow align="middle">
        <Link to="/?popout=login">
          {!forceReset && (
            <Button
              type={ButtonType.SecondaryAction}
              text={t('passwordResetPage.backToSignIn')}
            />
          )}
        </Link>
      </StyledBackButtonRow>

      <HeadlineTitle>{t('passwordResetPage.title')}</HeadlineTitle>

      <StyledDescriptionRow>
        <BodyText>
          {t(
            forceReset
              ? 'passwordResetPage.descriptionOnSetup'
              : 'passwordResetPage.descriptionOnReset',
            { name: name || email },
          )}
        </BodyText>
      </StyledDescriptionRow>
      <ThirdWidthRow>
        <Col span={24}>
          <PasswordResetForm />
        </Col>
      </ThirdWidthRow>
    </Flex>
  );
};
